"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var reactIntl=require("react-intl"),p=reactIntl.defineMessages({cancel:{defaultMessage:"Cancel",id:"app.components.ConfirmationModal.cancel"}});exports.default=p;
//# sourceMappingURL=messages.js.map
